import axios from 'axios';
import Vue from 'vue';

let api = axios.create({ baseURL: window.Config.BASE_URL });

api.defaults.timeout = 60000;

api.interceptors.response.use(response => {
	return response;
}, error => {
	if (error.response) {
		if (error.response.status === 401) {
			let route = location.hash.replace('#', '');

			Vue.prototype.$store.usuario = null;

			if (!route.startsWith('/login')) {
				location.href = `#/login?redirect=${route}`;
			}
		}
		return Promise.reject(error.response);
	}

	return Promise.reject(error);
});

export { api };

export default {
	fetchUsuario: () => api.get('/permisys'),
	atualizaTermo: (id, compartilha) => api.put(`/inscricao/${id}/aceiteTermo?compartilhamentoContato=${compartilha}`),
	logout: () => api.delete('/permisys'),

	sendForm: () => api.post('/inscricao/fluxo/enviar'),
	baixarProtocolo: () => api.get('/inscricao/protocolo'),

	fetchCadastro: () => api.get('/configuracaoCadastro'),

	fetchParams: () => api.get('/parametro'),

	fetchStatus: () => api.get('/inscricao/status'),
	fetchConfig: () => api.get(''),

	fetchResponsavel: () => api.get('/inscricao/responsavel'),
	fetchMembrosFamilia: () => api.get('/inscricao/membroFamilia'),

	fetchResidencia: () => api.get('/inscricao/residencia'),
	fetchComodos: () => api.get('/inscricao/comodo'),
	fetchFamiliasAdicionais: () => api.get('/inscricao/familiaAdicional'),
	fetchEndereco: cep => {
		let comdataURL = `https://api.sorocaba.sp.gov.br/COMDATA/endereco/pesquisarPorCep?cep=${cep}`;

		return axios.get(comdataURL);
	},

	fetchAnexos: () => api.get('/inscricao/anexo'),
	saveAnexo: (file, idPessoa, idTipoDocumento) => {
		let formData = new FormData();

		formData.append('file', file);

		return api.post(`/inscricao/anexo/${idPessoa}/${idTipoDocumento}`, formData, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		});
	},
	deleteAnexo: id => api.delete(`/inscricao/anexo/${id}`)
};